import { AnimalSpecies, HerdType } from 'app/agriculture/models/entities/herd/HerdAnimals';
import { IconManifest } from 'app/agriculture/icons/types';
import { MapIconOptions } from './types';

import {
    alpacaIcon,
    bullIcon,
    calfIcon,
    cowIcon,
    deerIcon,
    goatIcon,
    horseIcon,
    pigIcon,
    sheepIcon,
} from 'app/agriculture/icons/animals';
import { moveIcon } from 'app/agriculture/icons/animals/MoveIcon';

const animalIconConfig: Record<AnimalSpecies, { icon: IconManifest; options?: MapIconOptions }> = {
    Alpaca: {
        icon: alpacaIcon,
        options: { color: '#009688', billboardType: 'pin', shouldIncludeBorder: true },
    },
    Cow: {
        icon: cowIcon,
        options: { color: '#F44336', billboardType: 'pin', shouldIncludeBorder: true },
    },
    Deer: {
        icon: deerIcon,
        options: { color: '#9C27B0', billboardType: 'pin', shouldIncludeBorder: true },
    },
    Goat: {
        icon: goatIcon,
        options: { color: '#8BC34A', billboardType: 'pin', shouldIncludeBorder: true },
    },
    Horse: {
        icon: horseIcon,
        options: { color: '#FF9800', billboardType: 'pin', shouldIncludeBorder: true },
    },
    Pig: {
        icon: pigIcon,
        options: { color: '#03A9F4', billboardType: 'pin', shouldIncludeBorder: true },
    },
    Sheep: {
        icon: sheepIcon,
        options: { color: '#3F51B5', billboardType: 'pin', shouldIncludeBorder: true },
    },
} as const;

const herdTypeIconConfig: Partial<
    Record<HerdType, { icon: IconManifest; options?: MapIconOptions }>
> = {
    Bull: {
        icon: bullIcon,
        options: { color: '#F44336', billboardType: 'pin', shouldIncludeBorder: true },
    },
    Calf: {
        icon: calfIcon,
        options: { color: '#F44336', billboardType: 'pin', shouldIncludeBorder: true },
    },
    Cattle: animalIconConfig.Cow,
} as const;

export function getAnimalIconConfig(herdOptions: {
    animalSpecies: AnimalSpecies;
    herdType?: HerdType | null;
    totalAnimals: number;
    isMoveIcon?: boolean;
}) {
    const { animalSpecies, herdType, totalAnimals, isMoveIcon = false } = herdOptions;
    const icon =
        (herdType && herdTypeIconConfig[herdType]) ||
        animalIconConfig[animalSpecies] ||
        herdTypeIconConfig.Bull;

    const { icon: manifest, options = {} } = icon;

    return {
        icon: isMoveIcon ? moveIcon : manifest,
        options: { ...options, bubbleText: totalAnimals.toString() },
    };
}
